/**
 * Calendar-day helpers for Accounting date filters.
 * Grid columns show UTC dates via ISO string slice (`YYYY-MM-DD`).
 * Filters must use the same UTC day for timestamps, and the picker's
 * selected calendar day (local Y/M/D of the clicked cell) for ranges.
 */

/** UTC calendar day from an ISO / Date timestamp (matches grid `slice(0, 10)`). */
export const toUtcDateKey = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'string') {
    const match = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().slice(0, 10);
};

/** Calendar day the user selected in a date picker (local Y/M/D of that Date). */
export const toPickerDateKey = (value) => {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return null;
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * True when the job timestamp's UTC calendar day falls in [rangeStart, rangeEnd].
 * Empty range => always true. Missing job date with an active range => false.
 */
export const jobUtcDateMatchesRange = (dateValue, rangeStart, rangeEnd) => {
  if (!rangeStart && !rangeEnd) return true;
  const jobKey = toUtcDateKey(dateValue);
  if (!jobKey) return false;

  const startKey = toPickerDateKey(rangeStart);
  const endKey = toPickerDateKey(rangeEnd);

  if (startKey && endKey) return jobKey >= startKey && jobKey <= endKey;
  if (startKey) return jobKey >= startKey;
  if (endKey) return jobKey <= endKey;
  return true;
};
